import { gnhFormsFeatureToggle } from "./drivingExemptionApi";
import { applicationState } from "shared/store/applicationState"

export const loadFeatureToggles = async () => {
    const gnhFeature = await gnhFormsFeatureToggle();
    applicationState.setGNHFormsFeatureToggle(gnhFeature);
}